import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const ProfilePageSkeleton = ({ showPermissions = false }) => {
  return (
    <div className="profileMain" style={{ display: "flex" }}>
      <div style={{ width: "35%", marginLeft: "2rem" }}>
        <div
          className="skeleton"
          style={{ width: "220px", height: "38px", marginBottom: "2rem" }}
        ></div>

        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} style={{ marginTop: index === 0 ? "0" : "16px" }}>
            <div
              className="skeleton"
              style={{ width: "110px", height: "18px", marginBottom: "10px" }}
            ></div>
            <div
              className="skeleton"
              style={{ width: "100%", height: "46px", marginBottom: "0" }}
            ></div>
          </div>
        ))}

        <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
          <div
            className="skeleton"
            style={{ width: "140px", height: "42px", marginBottom: "0" }}
          ></div>
          <div
            className="skeleton"
            style={{ width: "160px", height: "42px", marginBottom: "0" }}
          ></div>
        </div>
      </div>

      {showPermissions && (
        <>
          <div
            style={{
              width: "1px",
              backgroundColor: "#ECECEC",
              margin: "0 2rem",
            }}
          />

          <div style={{ flex: 1, paddingRight: "2rem" }}>
            <div
              className="skeleton"
              style={{ width: "260px", height: "38px", marginBottom: "2rem" }}
            ></div>
            <div
              className="skeleton"
              style={{ width: "180px", height: "20px", marginBottom: "1.5rem" }}
            ></div>
            <div
              className="skeleton"
              style={{
                width: "100%",
                height: "150px",
                borderRadius: "20px",
                marginBottom: "0",
              }}
            ></div>
          </div>
        </>
      )}
    </div>
  );
};
